import React, { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import PageTitle from '../../../Components/PageTitle.js';
import { useParams } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import Tags from '../../../Components/Queries/Tags.js';
import { groupAndSimplifyTags, groupTagsFromTagsCache } from '../../../helpers/productTagFilter.js';
import { convertGraphQLLanguageName } from '../../../helpers/locale.js';
import AuthorLink from './Components/AuthorLink.js';
import AuthorById from '../../../Components/Queries/AuthorById.js';
import Container from '../../../Components/Store/Container.js';
import BBTranslate from '../../../Components/Locale/BBTranslate.js';
import ProductsWithFilterPicker from '../../../Components/Store/ProductsWithFilterPicker/ProductsWithFilterPicker.js';
import { LocaleContext } from '../../../Context';
import AuthorHeader from '../../../Components/Store/AuthorHeader.js';
import SubscriptionChip from '../../../Components/Store/Subscriptions/SubscriptionChip.js';
import { isFeatureOn } from '../../../helpers/featureFlag.js';

const useStyles = makeStyles((theme) => ({
  suitPattern: {
    left: 0
  },
  bioContainer: {
    marginTop: '4rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0
    }
  },
  linksList: {
    float: 'left',
    listStyle: 'none',
    margin: 0,
    padding: 0
  },
  linksListItem: {
    margin: 0,
    padding: 0
  },
  bio: {
    fontSize: '2rem',
    lineHeight: '2.8rem',
    paddingTop: '1rem',
    paddingRight: '12rem',
    [theme.breakpoints.down('md')]: {
      paddingRight: '8rem'
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      marginBottom: '3.5rem'
    }
  },
  groupHeading: {
    color: '#613344',
    margin: '5rem 0 4rem 0'
  },
  products: {
    marginTop: '4rem',
    // close up the gap between the products and the footer
    // otherwise there's a weird line of coloured background between them
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
      marginBottom: '-4rem'
    }
  }
}));

const Author = () => {
  const classes = useStyles();
  const params = useParams();
  const { authorId } = params;

  const { locale } = useContext(LocaleContext);

  if (!locale) {
    return null;
  }

  let hideSubscription = false;
  if (!isFeatureOn('subscriptions')) {
    hideSubscription = true;
  }

  return (
    <AuthorById id={parseInt(authorId)}>
      {
        data => {
          const hasSubscription = !hideSubscription && data.products.find(p => p.type === 'Subscription');
          return (
            <div>
              <PageTitle title={data.fullName} />
              <Container>
                <AuthorHeader
                  title={data.fullName}
                  author={data}
                  colour='#4788B1'
                >
                  {
                    hasSubscription && (
                      <SubscriptionChip />
                    )
                  }
                </AuthorHeader>
                <Grid container className={classes.bioContainer}>
                  <Grid item xs={12} sm={9} className={classes.bio}>
                    <Typography variant='body1'>
                      {data.bio}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <ul className={classes.linksList}>
                      {
                        data.authorLinks.map((link, index) => {
                          return (
                            <li key={index} className={classes.linksListItem}>
                              <AuthorLink link={link} />
                            </li>
                          );
                        })
                      }
                    </ul>
                  </Grid>
                </Grid>

                <div className={classes.products}>
                  <Tags groups='all'>
                    {(tagData) => {
                      const allTags = groupAndSimplifyTags(tagData, [], [], data.language);
                      const enabledTags = groupTagsFromTagsCache(data.tagsCache);

                      return (
                        <ProductsWithFilterPicker
                          headerText={<BBTranslate textId={['products-by', data.fullName]} />}
                          hardcodedTags={[[data.fullName]]}
                          contentLanguage={convertGraphQLLanguageName(data.language)}
                          availableTagsByGroupName={allTags}
                          enabledTagsByGroupName={enabledTags}
                          hideAuthor
                        />
                      );
                    }}
                  </Tags>
                </div>
              </Container>
            </div>
          );
        }
      }
    </AuthorById>
  );
};

export default Author;
